import {createBasicSelectors, makeSelect} from '../../utils/redux'
import {initialState} from './constants'
import {UserState} from './types'

const select = makeSelect<UserState>('user')

export const basicSelectors = createBasicSelectors<UserState>(initialState, select)
